<template>
    <v-form ref="form" v-model="valid" class="media-filter">
        <v-layout row>
            <v-flex>
                <div class="media-filter__title media-filter__title--top">VRN</div>
                <v-text-field
                    v-model="form.VRN"
                    label="Vehicle register number"
                    class="small-field"
                    required
                    outline
                    single-line
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <div class="media-filter__title">From Date</div>
                <date-picker
                    v-model="form.dateFrom"
                    placeholder="Pick date"
                    :clearable="false"
                    :default-value="new Date()"
                    :disabled-date="disabledAfterToday"
                    type="date"
                ></date-picker>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <div class="media-filter__title">To Date</div>
                    <date-picker
                        v-model="form.dateTo"
                        placeholder="Pick date"
                        :clearable="false"
                        :default-value="new Date()"
                        :disabled-date="disabledFromDateFromToToday"
                        type="date"
                    ></date-picker>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <div class="media-filter__title">Fleets</div>
                <fleet-autocomplete class="small-field" v-model="form.fleets" multiple></fleet-autocomplete>
            </v-flex>
        </v-layout>

    </v-form>
</template>

<script>
import moment from 'moment'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete.vue'
import DatePicker from 'vue2-datepicker'

export default {
    name: 'ResourceMediaFilter',
    components: {
        FleetAutocomplete,
        DatePicker
    },
    data () {
        return {
            valid: false,
            todayDate: null,
            isFromDatePickerShow: false,
            isToDatePickerShow: false,
            isDateFrom: ''
        }
    },
    props: {
        form: {
            type: Object,
            require: true
        }
    },
    mounted () {
        this.todayDate = moment().format('YYYY-MM-DD')
    },
    methods: {
        disabledAfterToday (dateFrom) {
            const today = new Date()
            this.isDateFrom = dateFrom
            return dateFrom > today
        },
        disabledFromDateFromToToday (dateTo) {
            const today = new Date()

            return dateTo < this.isDateFrom || dateTo > today
        }
    }
}
</script>

<style scoped lang="scss">

.media-filter {
    &__title {
        margin-bottom: 10px;

        &--top {
            margin-top: 20px;
        }
    }
}

::v-deep .v-text-field.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field.v-text-field--enclosed .v-input__append-inner,
.v-text-field.v-text-field--enclosed .v-input__append-outer {
    display: none !important;
}

::v-deep .v-input .v-input__slot {
    background-color: #fff !important;
}

::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
}

::v-deep .mx-datepicker {
    margin-bottom: 10px;
}
</style>
